<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Order from "@/components/orderComponent"


/**
 * Orders-list component
 */
export default {
  page: {
    title: "Commande",
    meta: [{ name: "description", content: appConfig.description }]
  },

  props: {
    orderId: {
      type: Number,
      default: 0,
    }
  },



  components: { Layout,Order},
  data() {
    return {
        
    };
  },  
  

}

</script>

<template>
  <Layout>
    <Order :orderId= this.orderId /> 
  </Layout>
</template>